<!-- session-timeout-modal.component.html -->
@if (isModalVisible) {
  <div class="session-timeout-modal">
    <div class="session-timeout-modal-content">
      <!-- Modal Header -->
      <div class="session-timeout-modal-header">
        <h2>Session Timeout</h2>
        <span class="session-timeout-close" (click)="closeModal()">&times;</span>
      </div>
      <!-- Modal Body -->
      <div class="session-timeout-modal-body">
        <div class="session-modal-title " tabindex="0" [id]="'sessionTimeout-header'">
          @if (isUserLogin) {
            <span class="loggedInUserHeader">{{string_LoggingOutTimingWording}}</span>
          }
          @if (!isUserLogin) {
            <span>{{string_SessionClosingWording}}</span>
          }
        </div>
        <span class="timeCounter" id="msgContent" aria-labelledby="timeCounter">{{countDown | async}}</span>
      </div>
      <!-- Modal Footer -->
      <div class="session-timeout-modal-footer">
        <div class="clear-all login-register-div" #continueBtn tabindex="0">
          <button id="loginBtn" name="loginBtn" tabindex="0" (click)="continueSession()"
            class="session-button session-timeout-button btn1 keepMeLoggedIn-btn pointer reflect"
            [ngClass]="isUserLogin ? 'session-button session-timeout-button btn1 keepMeLoggedIn-btn pointer reflect' : 'session-button session-timeout-button keepMeLoggedIn-btn pointer reflect ' ">
            <span class="keepMeLoggedIn-text" id="loginText" aria-live="polite">
              @if (!isUserLogin) {
                <span
                aria-labelledby="continue with my session">{{string_ContinueSessionCTALabel}}</span>
              }
              @if (isUserLogin) {
                <span aria-labelledby="keep me logged in">{{string_KeepLoggedInCTALabel}}</span>
              }
            </span>
          </button>
          @if (!isUserLogin) {
            <div class="retriveQuote" #loginBtn tabindex="0">
              <!-- *ngIf="!isUserLogin" -->
              <span>If you want to retrieve your quote later, you will need to
                <div style="display:inline-flex;align-items: center">
                  <div #loginBtn>
                    <a class="hyperLinkColor" (keyup.enter)="login()" (click)="login()" tabindex="0"
                    aria-labelledby="login">login</a>
                  </div>
                  or
                  <div #registerBtn>
                    <a (click)="registration()" (keyup.enter)="registration()" class="hyperLinkColor" tabindex="0"
                    aria-labelledby="register">register</a>
                  </div>
                </div>
              </span>
            </div>
          }
          @if (isUserLogin) {
            <div class="form-field btn2  keepMeLogoutUser-btn" #loginBtn tabindex="0">
              <a id="logoutLink" name="logoutLink" tabindex="0" class="keepMeLoggedIn-text logoutText"
              (keyup.enter)="logout()" (click)="logout()">Logout</a>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}